/**
 * Formats a duration in seconds into the desired format:
 * - HH:MM:SS for double digit hours
 * - H:MM:SS for single digit hours
 * - MM:SS for less than 1 hour and double digit minutes
 * - M:SS for less than 1 hour and single digit minutes
 * - 0:SS for less than 1 minute
 */
export const formatDuration = (duration: string): string => {
  // Convert duration to seconds
  const totalSeconds = parseInt(duration, 10);
  
  // Handle invalid duration
  if (isNaN(totalSeconds)) {
    return duration;
  }

  // Calculate hours, minutes, and remaining seconds
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  
  // Format seconds with leading zero
  const formattedSeconds = seconds.toString().padStart(2, '0');
  
  if (hours > 0) {
    // Format for hours
    const formattedMinutes = minutes.toString().padStart(2, '0');
    if (hours >= 10) {
      // Double digit hours: HH:MM:SS
      return `${hours}:${formattedMinutes}:${formattedSeconds}`;
    } else {
      // Single digit hours: H:MM:SS
      return `${hours}:${formattedMinutes}:${formattedSeconds}`;
    }
  } else if (minutes > 0) {
    if (minutes >= 10) {
      // Double digit minutes: MM:SS
      return `${minutes}:${formattedSeconds}`;
    } else {
      // Single digit minutes: M:SS
      return `${minutes}:${formattedSeconds}`;
    }
  } else {
    // Less than 1 minute: 0:SS
    return `0:${formattedSeconds}`;
  }
};
